import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-parent-category',
  templateUrl: './parent-category.component.html',
  styleUrls: ['./parent-category.component.scss']
})
export class ParentCategoryComponent {

  @Input() parentCategoryBreadcrumb: string;

  constructor() { }

 }



// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/containers/parent-category/parent-category.component.ts